import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { StudentSignUpHeroSection } from '../StudentSignUpHeroSection';
import { StudentSignUpFormSection } from '../StudentSignUpFormSection';
export const StudentSignUp = () => {
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-5993">
      <Navbar data-id="element-5994" />
      <main data-id="element-5995">
        <StudentSignUpHeroSection data-id="element-5996" />
        <StudentSignUpFormSection data-id="element-5997" />
      </main>
      <Footer data-id="element-5998" />
    </div>;
};